import {
    Dialog, DialogContent,
    DialogContentText, Grid
} from "@material-ui/core";
import closeIcon from '../../../assets/images/close.svg';



export default function BiomarkersDialog(props) {
    const { show, hide, type, _packageData } = props;

    return (
        <>
            <Dialog
                open={show}
                onClose={hide}
                fullWidth
                fullHeight
                maxWidth={'sm'}

            >
                <Grid style={{ display: 'flex', allignItem: 'end', justifyContent: 'end', marginTop: '2%', marginRight: '2%', cursor: 'pointer' }} onClick={() => props.hide()}> <img src={closeIcon} alt='' /></Grid>

                <DialogContent>

                    <DialogContentText variant='h6'>Investigation Areas</DialogContentText>
                    <Grid
                        item
                        xs={12}
                        style={{
                            height: 'auto',
                            width: 'auto',
                            background: "#F2F8F9",
                        }}
                    >
                        <ol>
                            {_packageData && _packageData.investigation_area && _packageData.investigation_area.length > 0 &&
                                _packageData.investigation_area.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                        </ol>
                    </Grid>

                    <DialogContentText variant='h6'>Biomarkers</DialogContentText>

                    <Grid
                        item
                        xs={12}
                        style={{
                            paddingTop: '2%',
                            height: 'auto',
                            width: 'auto',
                            background: "#F2F8F9",
                        }}
                    >
                        <ol >
                            {_packageData && _packageData.biomarks && _packageData.biomarks.length > 0 &&
                                _packageData.biomarks.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                        </ol>
                    </Grid>
                </DialogContent>

            </Dialog>
        </>
    )
}